(function ($, root, undefined) {
	
	$(function () {
		
		'use strict';

		function checkIfMobile(){
			var isMobile = false;
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;
			    
			if(isMobile == true){
				$('body').removeClass('no-touch');
				$('#topheader').removeClass('preanimation');
			}
		}

		checkIfMobile();
		
		var resizeDone, scrollingDone;
		var expertsSlides = 0;
		var expertsSlideWidth = 0;
		var expertSliderExists = false;
		var startpuffarSliderExists = false;
		var relatedPuffarSliderExists = false;
		var startpuffarCount = 0;
		var relatedPuffarCount = 0;
		var msnry;
		var expertsSwiper = false;
		var puffSwiper = false;
		var relatedSwiper = false;
		var refreshedPage = true;
		var snHeight = 0;
		var windowWidth = $(window).width();
		
		if($('body.home').length > 0){
			$(window).scroll(function(){
				clearTimeout(scrollingDone);
				scrollingDone = setTimeout(doneScrollingHome, 0);
			});
		}
		var cookieAccepted = false;
		if(window.localStorage!==undefined && localStorage.getItem('cookieAccepted') !== undefined){
			cookieAccepted = localStorage.getItem('cookieAccepted');
		}

		console.log(cookieAccepted);
		if(cookieAccepted){
			
		} else{
			$('.cookiepolicy').show();
			console.log('show');
		}

		window.showGrade = function (){
			$( ".previewGrade" ).each(function( index ) {
			  var data = Math.round($(this).attr('data'));
				if($(this).children().length < 2){
					for (var i=0; i<5; ++i ){
					 if(data >= 1){
						  $(this).prepend('<span class="star full"></span>');
					  }
					  else{
						  $(this).prepend('<span class="star empty"></span>');
					  }	
					  data = data - 1
					}
				}
			});
		}
		if($('.puff.recept').length > 0){
			showGrade();	
		}
		$('nav').on('click', '#hamburger', function(e){
			$('#mobile-nav').toggleClass('active');
			$(this).toggleClass('active');
		});

		$('.cookiepolicy').on('click', 'button', function(e){
			e.preventDefault();
			localStorage.setItem('cookieAccepted', true);
			$('.cookiepolicy').remove();
		});
	
		function startPageMasonry(){
			if($('.slideron .startpuff-swiper').length < 1){
				var container = document.querySelector('.startpuffar');

			    msnry = new Masonry( container, {
			      	itemSelector : '.puffholder',
				  	columnWidth: '.widthcontrol',
				  	percentPosition: true,
				});
			}
		}
		
		$(window).resize(function(){
			clearTimeout(resizeDone);
			resizeDone = setTimeout(doneResizing, 500);
		});

		window.insertMoreChoicesLink = function(){
			$('#filter .tags li.tag').removeClass('hidden');
			$('#filter .tags li.more').remove();
			if($('#filter .tags').length > 0){
				var count = 0;
				var maxHeight = $('#filter .tags').height();

				var firstElemUnderMaxHeight = false;
				var listOffset = $('#filter .tags').offset().top;
				
				$('#filter .tags li.tag').each(function(){
					if($(this).offset().top > (listOffset + maxHeight)){
					
						if(!firstElemUnderMaxHeight){
							firstElemUnderMaxHeight = count;
						}
					}
					count++;
				});

				if(firstElemUnderMaxHeight){
					for(var i = firstElemUnderMaxHeight - 2; i < count + 1; i++){
						$('#filter .tags li.tag').eq(i).addClass('hidden');
					}

					$('#filter .tags li.tag').eq(firstElemUnderMaxHeight - 3).after('<li class="more">Fler val</li>');
				}

				
				
			}
		}

		//Allt som körs när man resizar fönstret
		function doneResizing(){
			if(windowWidth != $(window).width()){
				window.insertMoreChoicesLink();
				if($('.experts .swiper-wrapper').length > 0){
					checkExpertsSliderOnOff();
				}
				if($('.startpuffholder .swiper-wrapper').length > 0){
					startpuffarOnOff();
				}
				if(relatedPuffarSliderExists){
					checkRelatedPuffarSliderOnOff();
				}

				if($('body.single-recipes')){
					checkIngredientsHeight();
				}
				
				windowWidth = $(window).width();	
			}
		}

		function checkIngredientsHeight(){
			var wasActive = false;
			var $ingredients = $('.ingredients');
			var winHeight = $(window).height() -75;


			if($ingredients.hasClass('active')){
				wasActive = true;
			} else{
				$ingredients.hasClass('active');
			}

			$ingredients.height('auto');

			var ingHeight = $ingredients.height();

			if(winHeight > ingHeight){
				if($(document).width() < 501){
					$ingredients.height(ingHeight);
				}
				
			} else{
				if($(document).width() < 501){
					$ingredients.height(winHeight);
				}
			}

			if(!wasActive){
				$ingredients.removeClass('active');
			}
		}

		function checkExpertsSliderOnOff(){
			var sliderWidth = $('.experts .swiper-wrapper').width();
			if(sliderWidth < (expertsSlides * expertsSlideWidth) + 20 && $(document).width() < 800){
				initExpertsSlider();
			} else{
				if(expertsSwiper){
					destroyExpertsSlider();
				}
			}
		}

		function checkRelatedPuffarSliderOnOff(){
			if($(window).width() < 600){
				initRelatedPuffarSlider();
			} else{
				if(relatedSwiper){
					destroyRelatedPuffarSlider();
				}
			}
		}

		window.urlParam = function(name, w){
			    w = w || window;
			    var rx = new RegExp('[\&|\?]'+name+'=([^\&\#]+)'),
			        val = w.location.search.match(rx);
			    return !val ? '':val[1];
			}
		if($('#baklexikon').length > 0){
			if(window.location.href.indexOf("?") > -1) {
			  	var question = urlParam('word');			
			  	question = question.slice(1, -1);			  	

				var div = '.' + question;
				var offset = $(div).offset();
			    var scrolltoY = offset.top;
			    var scrolledSubnavHeight;
			    var subnav = $('.subnavigation');

			    if(subnav.hasClass('scrolled')){
			    	scrolledSubnavHeight = subnav.height();
			    } else{
			    	subnav.addClass('scrolled');
			    	scrolledSubnavHeight = subnav.height();
			    	subnav.removeClass('scrolled');
			    }

				$('html,body').animate({ scrollTop: scrolltoY - scrolledSubnavHeight - 70 }, 500);

				$('.' + question).addClass('active');
			}
				
			$('.scrollToLetter').on('click', function(e){
				e.preventDefault();
				var letter = $(this).data('letter');
				var div = '.lettersection.letter-' + letter;
				var offset = $(div).offset();
			    var scrolltoY = offset.top;
			    var scrolledSubnavHeight;
			    var subnav = $('.subnavigation');

			    if($('.subnavigation').hasClass('scrolled')){
			    	scrolledSubnavHeight = subnav.height();
			    } else{
			    	subnav.addClass('scrolled');
			    	scrolledSubnavHeight = subnav.height();
			    	subnav.removeClass('scrolled');
			    }

				$('html,body').animate({ scrollTop: scrolltoY - scrolledSubnavHeight - 70 }, 500);
			});
			$(window).scroll(function (event) {
		    	var scroll = $(window).scrollTop();
				var top = $('.subnavigation').offset().top - 20;
				var snHeight = $('.subnavigation').height();
				if(scroll >= top){
			    	if($('.subnavigation').hasClass('scrolled')){

			    	}else{
			    		$('.subnavigation').addClass('scrolled');
				    	$('.scrollheight').height(snHeight);
			    	}
			    }
				if(scroll < 175){
			    	$('.subnavigation').removeClass('scrolled');
			    	$('.scrollheight').height(0);
		    	}


			});
		}

		function goToByScroll(div){
		    var offset = $(div).offset();
		    var scrolltoY = offset.top;
			if($('body.no-touch').length > 0){
				$('html,body').animate({ scrollTop: scrolltoY - 120 }, 500);
			}
			else{
				$('html,body').animate({ scrollTop: scrolltoY - 160 }, 500);
			}
		    
		}

		$('body').on('click', '.js-flerstartpuffar', function(e){
			e.preventDefault();
			loadStartPuffar();
		});
		$('body').on('click', '.menu-item', function(e){
			if($('#mobile-nav').hasClass('active')){
				$('#mobile-nav').removeClass('active')
			}

			setTimeout(function(){
				if(window.location.hash == '#recept'){
				var offset = $('#scroll-to-recepies').offset();
				var scrolltoY = offset.top;
				$('html,body').animate({ scrollTop: scrolltoY - 90 }, 500);
					}
			}, 400);
				
		});
		//Ladda fler puffar
		function loadStartPuffar(){
			var puffCount = 0;
			var keepButton = false;
			$('.startpuffar li.puffholder').each(function(){
				// if(puffCount < 8) {
					$(this).removeClass('hidden').removeClass('hidden-by-count').find('.puff').addClass('hidden');
					puffCount++;
				// }
				if(puffCount < 7) {
					keepButton = true;
				}
			});

			if (!$('.startpuffar li.puffholder').filter('.hidden-by-count').length) {
				$('.home .buttonholder').addClass('hidden');
			}

			setTimeout(function(){
				$('.startpuffar li.puffholder .puff.hidden').removeClass('hidden');
				if(!keepButton){
					$('.js-flerstartpuffar').hide();
				}
			}, 500);

			setTimeout(function(){
				startPageMasonry();
			}, 300);

			setTimeout(function(){
				startPageMasonry();
			}, 600);

			setTimeout(function(){
				startPageMasonry();
			}, 1400);

			setTimeout(function(){
				startPageMasonry();
			}, 3400);

			// if(!keepButton){
			// 	$('.home .buttonholder').addClass('hidden');
			// 	setTimeout(function(){
			// 		$('.home .buttonholder').hide();
			// 	}, 300);
			// }
		}

		function startpuffarOnOff(){
			if($('.startpuffholder .swiper-wrapper').length > 0){
				if(startpuffarCount > 3 && $(document).width() < 580){
					initStartPuffarSlider();
				} else{
					if(puffSwiper){
						destroyStartPuffarSlider();
					}
				}
			}
		}

		// https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/js/swiper.js
		function initStartPuffarSlider(){
			destroyStartPuffarMasonry();
			var startpuffHolder = $('.startpuffholder');
			$('.startpuffholder').removeClass('no-slider').addClass('slideron');
			puffSwiper = new Swiper('.startpuff-swiper', {
		        slidesPerView: 'auto',
		        centeredSlides: true,
		        speed: 1000,
		        spaceBetween: 10,
		        loop: true,
		        onDestroy: function() {
				 	$('.startpuffholder').addClass('no-slider').removeClass('slideron').find('.puff').height('auto');
				 	$('.startpuffholder').find('.swiper-wrapper').removeAttr('style');
				 	$('.startpuffholder').find('.swiper-slide').removeAttr('style');
					setTimeout(
						startPageMasonry(), 400);
					$('.js-flerstartpuffar').removeClass('hidden');
				}
		    });
			var newHeight = 0;
		    setTimeout(function(){
		    	startpuffHolder.find('.puff').each(function(){
			    	$(this).css('height', 'auto');
			    	var tempHeight = $(this).outerHeight();
			    	if(tempHeight > newHeight){
			    		newHeight = tempHeight;
			    	}
		    	});
		    }, 200);

		    setTimeout(function(){
		    	startpuffHolder.find('.puff').each(function(){
		    		$(this).height(newHeight);
		    	});
		    	$('.startpuff-swiper').height(newHeight + 30);
		    }, 600);

		    setTimeout(function(){
		    	startpuffHolder.find('.puff').each(function(){
			    	$(this).css('height', 'auto');
			    	var tempHeight = $(this).outerHeight();
			    	if(tempHeight > newHeight){
			    		newHeight = tempHeight;
			    	}
		    	});
		    }, 1500);

		    setTimeout(function(){
		    	startpuffHolder.find('.puff').each(function(){
		    		$(this).height(newHeight);
		    	});
		    	$('.startpuff-swiper').height(newHeight + 30);
		    }, 1600);

		    $('.js-flerstartpuffar').addClass('hidden');
		 
		}

		function doneScrollingHome() {
			var scroll = $(window).scrollTop();
			var top = $('nav.nav').offset().top - 60;
			var bottom = ($('nav.nav').offset().top + $('.subnavigation').height()) - 300;

			if (scroll >= top && $('body.no-touch').length > 0) {
				$('header').removeClass('preanimation');
			}
			if (scroll < 30 && $('body.no-touch').length > 0) {
				$('header').addClass('preanimation');
			}
		}

		function destroyStartPuffarSlider(){
			setTimeout(function(){
				puffSwiper.destroy(false, true);
			}, 100);
		}

		function destroyRelatedPuffarSlider(){
			setTimeout(function(){
				relatedSwiper.destroy(false, true);
			}, 100);
		}

		function destroyStartPuffarMasonry(){
			if(msnry){
				msnry.destroy();
			}
		}

		// https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/js/swiper.js
		function initRelatedPuffarSlider(){
			var relatedpuffHolder = $('.relatedpuffholder');
			$('.relatedpuffholder').removeClass('no-slider').addClass('slideron');
			relatedSwiper = new Swiper('.relatedpuff-swiper', {
				slidesPerView: 'auto',
				observer: true,
				centeredSlides: true,
				observeParents: true,
				watchSlidesProgress: true,
				speed: 1000,
				spaceBetween: 10,
				loop: true,
				preloadImages: true,
				updateOnImagesReady: true,
				onImagesReady: function() {
					var maxHeight = 0;
					var $relatedRecipes = $('#related-recipes');
					$relatedRecipes.find('.recept').each(function () {
						var $obj = $(this);
						var currentHeight = $obj.height();
						if (currentHeight > maxHeight) {
							maxHeight = currentHeight;
						}
					});
					$relatedRecipes.find('.recept').height(maxHeight + 40);
				},
				onDestroy: function() {
				 	$('.relatedpuffholder').addClass('no-slider').removeClass('slideron').find('.puff').height('auto');
				 	$('.relatedpuffar').removeAttr('style');
				 	$('.relatedpuffar').find('.swiper-slide').removeAttr('style');
					$relatedRecipes.find('.recept').removeAttr('style');
				 	setTimeout(function(){
				 		$('.relatedpuffar').removeAttr('style');
				 		$('.relatedpuffar').find('.swiper-slide').removeAttr('style');
				 	}, 200);
				}
		    });
		}

		function getQueryVariable(variable){
	        var query = window.location.search.substring(1);
	        var vars = query.split("&");
	        for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				if(pair[0] == variable){return pair[1];}
	        }
	        return(false);
		}

		var hash = window.location.hash;

		//Scroll to div with class if exists in URL
		var scrollToThis = getQueryVariable('scroll');
		if(scrollToThis){
			setTimeout(function(){
				goToByScroll('.' + scrollToThis);
			}, 800);
		}

		function initStartPuffar(){
			var puffCount = 0;
			$('.startpuffar li.puffholder').each(function(){
				if(puffCount > 6){
					$(this).addClass('hidden-by-count').addClass('hidden');
				}
				puffCount++;
			});
		}
		
		function initExpertsSlider(){
			$('.js-experts').removeClass('no-slider').addClass('slideron');
			expertsSwiper = new Swiper('.experts-swiper', {
				slidesPerView: 'auto',
				centeredSlides: false,
				spaceBetween: 0,
				loop: false,
				onDestroy: function() {
					$('.js-experts').addClass('no-slider').removeClass('slideron');
				}
			});
		}

		function destroyExpertsSlider(){
			setTimeout(function(){
				expertsSwiper.destroy(false, true);
			}, 100);
		}

		function init(){
			if($('body.single-recipes')){
				checkIngredientsHeight();
			}
		}

		$(document).ready(function(){
			init();

			/* basic - default settings */
			if($('.home.page').length > 0){
				if($('.experts .swiper-wrapper').length > 0){
					expertSliderExists = true;
					expertsSlides = $('.experts .swiper-wrapper').find('li').length;
					expertsSlideWidth = $('.experts .swiper-wrapper').find('li').eq(0).outerWidth();
					checkExpertsSliderOnOff();				
				}

				if($('.startpuffholder .swiper-wrapper').length > 0){
					startpuffarSliderExists = true;
					startpuffarCount = $('.startpuffholder .swiper-wrapper').find('li').length;
					initStartPuffar();
					startpuffarOnOff();
					setTimeout(function(){
						startPageMasonry();
					}, 500);

					setTimeout(function(){
						startPageMasonry();
					}, 1400);

					setTimeout(function(){
						startPageMasonry();
					}, 2400);

					setTimeout(function(){
						startPageMasonry();
					}, 4400);					
				}

				if($('body.home').length > 0){
					if(hash == '#recept'){
						setTimeout(function(){
							var offset = $('#scroll-to-recepies').offset();
						    var scrolltoY = offset.top;
							$('html,body').animate({ scrollTop: scrolltoY - 90 }, 500);
							
						}, 1400);
					}
				}
			}
			
			if($('.relatedpuffar.swiper-wrapper').length > 0){
				relatedPuffarSliderExists = true;
				relatedPuffarCount = $('.relatedpuffar.swiper-wrapper').find('li.puff').length;
				setTimeout(function(){
					checkRelatedPuffarSliderOnOff();
				}, 200);
			}

			if($('body.single-recipes').length > 0 || $('body.single-recipecollections').length > 0 || $('body.single-experts').length > 0){
				$('.menu-item-221').addClass('current-menu-item');
			}
		});
		
	});
	
})(jQuery, this);
